// extracted by mini-css-extract-plugin
module.exports = {"ant-form-item":"userInformation_ant-form-item_3QOGs","btnPasswordGenerator":"userInformation_btnPasswordGenerator_2Lg1A"};